import { api } from 'api'
import { path } from 'ramda'
import { TimelineShift } from 'api/shift'

export async function getReviewOvertimeApprovalShifts() {
  const data = await api.post(
    '/company/graphql_dispatch/shifts_to_review_needs_attention_9c817ffd',
    {}
  )

  return path(
    ['data', 'data', 'company', 'overtimeReviewShifts'],
    data
  ) as TimelineShift[]
}
